(function () {
    document.querySelectorAll('.ingredients__view-all').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var overflowId = btn.getAttribute('data-overflow-id');
        var overflow = document.getElementById(overflowId);
        if (overflow) {
          overflow.style.display = 'flex';
          overflow.offsetHeight;
          overflow.style.maxHeight = overflow.scrollHeight + 'px';
          overflow.addEventListener('transitionend', function () {
            overflow.style.maxHeight = 'none';
          }, { once: true });
        }
        btn.classList.add('ingredients__view-all--hidden');
        btn.addEventListener('transitionend', function () {
          btn.style.display = 'none';
        }, { once: true });
      });
    });
  })();